module.exports = __webpack_public_path__ + "static/media/person-running.e97ebb71.svg";